import React from 'react';
import {
  Button,
  Descriptions,
  Form,
  Input,
  InputNumber,
  Space,
  DatePicker,
} from 'antd';
import { CopyOutlined } from '@ant-design/icons';

/**
 * RegularDeliveryForm — форма обычной (не СДЭК) доставки.
 *
 * Props:
 *  - onCopyField: (fieldName: string) => void
 */
const RegularDeliveryForm = ({ onCopyField }) => (
  <>
    <Descriptions column={1} bordered size="small">
      <Descriptions.Item label="Адрес">
        <Space style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
          <Form.Item name="address" style={{ flex: 1, marginBottom: 0 }}>
            <Input variant="borderless" />
          </Form.Item>
          <Button icon={<CopyOutlined />} onClick={() => onCopyField('address')} />
        </Space>
      </Descriptions.Item>

      <Descriptions.Item label="Стоимость доставки">
        <Space style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
          <Form.Item
            name="delivery_price"
            style={{ flex: 1, marginBottom: 0 }}
            rules={[{ type: 'number', min: 0, message: 'Стоимость должна быть положительным числом' }]}
          >
            <InputNumber
              placeholder="Введите стоимость"
              style={{ width: '100%' }}
              min={0} step={1} precision={2}
              variant="borderless"
            />
          </Form.Item>
          <span>₽</span>
        </Space>
      </Descriptions.Item>

      <Descriptions.Item label="Дата доставки">
        <Form.Item name="delivery_date" style={{ flex: 1, marginBottom: 0 }}>
          <DatePicker
            showTime format="DD.MM.YYYY HH:mm"
            style={{ width: '100%' }}
            placeholder="Выберите дату и время"
            variant="borderless"
          />
        </Form.Item>
      </Descriptions.Item>

      <Descriptions.Item label="Примечание">
        <Form.Item name="note" style={{ flex: 1, marginBottom: 0 }}>
          <Input.TextArea autoSize variant="borderless" placeholder="Дополнительная информация" />
        </Form.Item>
      </Descriptions.Item>
    </Descriptions>

    <Descriptions column={1} bordered size="small" title="Получатель" style={{ marginTop: 16 }}>
      <Descriptions.Item label="Имя">
        <Space style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
          <Form.Item
            name="recipient_fullname"
            style={{ flex: 1, marginBottom: 0 }}
            rules={[{ required: true, message: 'Введите имя получателя' }]}
          >
            <Input placeholder="Имя получателя" variant="borderless" />
          </Form.Item>
          <Button icon={<CopyOutlined />} onClick={() => onCopyField('recipient_fullname')} />
        </Space>
      </Descriptions.Item>

      <Descriptions.Item label="Телефон">
        <Space style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
          <Form.Item
            name="recipient_phone"
            style={{ flex: 1, marginBottom: 0 }}
            rules={[{ required: true, message: 'Введите телефон получателя' }]}
          >
            <Input placeholder="+7 (999) 999-99-99" variant="borderless" />
          </Form.Item>
          <Button icon={<CopyOutlined />} onClick={() => onCopyField('recipient_phone')} />
        </Space>
      </Descriptions.Item>
    </Descriptions>
  </>
);

export default RegularDeliveryForm;